exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-page .top_form[data-v-38546064]{border:1px solid rgba(0,0,0,.1);padding:.2rem .24rem}.point-page .sub_title[data-v-38546064]{font-size:.18rem;font-family:Roboto-Bold,Roboto;font-weight:bold;color:#000;line-height:.28rem;margin-bottom:.16rem;display:flex;justify-content:space-between}.point-page .sub_title.img[data-v-38546064]{justify-content:flex-start}.point-page .well_box[data-v-38546064]{background-color:#fafafa;padding:.24rem .32rem;box-sizing:border-box}.tip_box[data-v-38546064]{position:relative}.tip_box .tip_btn[data-v-38546064]{position:absolute}.tip_box .tip_val[data-v-38546064]{margin-left:.14rem}", ""]);

// exports
